import { render } from "./ExtractPalette.vue?vue&type=template&id=1c4aa6ce&scoped=true"
import script from "./ExtractPalette.vue?vue&type=script&lang=js"
export * from "./ExtractPalette.vue?vue&type=script&lang=js"

import "./ExtractPalette.vue?vue&type=style&index=0&id=1c4aa6ce&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4aa6ce"]])

export default __exports__